import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/utilities/auth.service';
import { TranslationService } from 'src/app/services/utilities/translation.service';
import { PostService } from 'src/app/services/repositories/post.service';
import { ScreenSizeService } from 'src/app/services/utilities/screen-size.service';
import { DatePipe } from '@angular/common';
import { StatsIcon } from 'src/app/enums/statsSVGIcon';
import { SocialMediaAPIService } from 'src/app/services/utilities/socialMediaApi.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { ICON } from 'src/app/interfaces/ModalIcon';


@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  providers: [DatePipe]  
})
export class HomePageComponent {
  @ViewChild('container') container!: ElementRef;
  height: number = 0;
  private observer!: MutationObserver;

  user: any;
  post: any = {}; 
  plannedPosts: any = []; 
  linkedin : boolean = false;
  google : boolean = false;
  facebook : boolean = false;
  instagram : boolean = false;
  linkedinData: any = null;
  linkedinMedias: any[] = []
  googleData: any = null;
  googleMedias: any[] = []
  facebookData: any = null;
  facebookMedias: any[] = []
  instagramData: any = null;
  instagramMedias: any[] = []
  mediaAllpreview: any =  null;
  screenWidth: number = 0;
  screenHeight: number = 0;
  dates: string[] = []
  currentGroups: number[] = [];
  isLoading: boolean = false;
  doneLoadingPosts: boolean = false;
  previousScrollPosition = 0;
  allData: any = {};
  navigation: any = {
    limit: 3,
    itemsPerPage: 3,
    page: 0,
    offset: 0
  };
  groups: any[] = [];
  env = environment;
  isGroupNamesToolTip: boolean = false;
  isTruncated: boolean = false;
  postHour: string = '00';
  postMinute: string = '00';
  tabs: any[] = [];
  activeTab: string = '';
  top: any[] = [];
  comments: any[] = [];
  hideStats: boolean = false;
  noStatsMsg: string = "";

  SetIconShare() : StatsIcon { return StatsIcon.SHARE }
  SetIconReactions() : StatsIcon {return StatsIcon.REACTIONS}
  SetIconInteraction() : StatsIcon {return StatsIcon.INTERACTION}
  SetIconImpression() : StatsIcon {return StatsIcon.IMPRESSION}
  SetIconChatBubble() : StatsIcon {return StatsIcon.CHAT_BUBBLE}
  SetIconEngagement() : StatsIcon { return StatsIcon.ENGAGEMENT }

  isLoadingLatestPost: boolean = true;
  isLoadingPlannedPost: boolean = true;
  isLoadingTopPosts: boolean = true;
  isLoadingComments: boolean = true;

  constructor(protected authService: AuthService, protected translationService:TranslationService, protected postService: PostService, private datePipe: DatePipe,
    private screenSizeService: ScreenSizeService,
    private socialMediaAPIService: SocialMediaAPIService,
    private elementRef: ElementRef
  ){}
  subscriptions:Subscription[] = [];
  ngOnInit(): void {
    this.screenSizeService.screenWidth$.subscribe(
      (width: number) => (this.screenWidth = width)
    );
    this.screenSizeService.screenHeight$.subscribe(
      (height: number) => (this.screenHeight = height)
    );
    this.user = this.authService.loadUserfromLs();
    this.currentGroups =this.postService.getGroupScopesFromLocalStorage();
    this.subscriptions.push( this.postService.currentGroups.subscribe(
      (g) => {
        // console.log('g', g);
        
        if (g.length == 0)
          g = this.postService.getGroupScopesFromLocalStorage();
        
        if (g.length > 0) {
          this.currentGroups = g;
          this.getLastPost();
          this.getLastPlannedPosts();
          this.topPosts('30')
          this.getComments();

        }
      }
    ));
    
    // console.log('allData',this.allData);
  }



  externLinks(link: string){
    window.location.href = link
  }
  tr(key: string){
    return this.translationService.t(key)
  }

  getUserFirstName(): string {
    return this.authService.loadUserfromLs()?.firstName
  }

  getLastPost(){
    this.subscriptions.push(this.postService.getLastPost(this.currentGroups).subscribe((res: any)=>{
      if(this.isNotEmptyObject(this.post)){
        this.resetIntialData();
        this.getLastPlannedPosts();
      }
      if(res.data){
        this.post =  res.data;
        // console.log('this.posts', this.post);
        this.post.SocialPlatforms.forEach((item: {group: any;postAnalytics: any; source: string; medias: any})=>{
          if (!this.groups.some(group => group.id === item.group.id) && this.currentGroups.includes(item.group.id)){
            this.groups.push({id: item.group.id, name: item.group.name, logo: item.group.logoUrl})
          }
          if(item.source == "linkedin"){
            if(item.medias.length>0)
              this.googleMedias = item.medias;
            this.linkedin = true;
          }
          if(item.source == "google"){
            if(item.medias.length>0)
              this.linkedinMedias = item.medias;
            this.google = true;
          }
         if(item.source == "facebook"){
            if(item.medias.length>0)
              this.facebookMedias = item.medias;
            this.facebook = true;
          }
         if(item.source == "instagram"){
            if(item.medias.length>0)
              this.instagramMedias = item.medias;
            this.instagram = true;
          }
        })
        this.allData.impression = this.post?.postAnalytics?.impression != null ? this.post?.postAnalytics?.impression : '-'; 
        this.allData.reactions = this.post?.postAnalytics?.reactions != null ? this.post?.postAnalytics?.reactions : '-'; 
        this.allData.interactions = this.post?.postAnalytics?.interactions != null ? this.post?.postAnalytics?.interactions : '-'; 
        this.allData.shares = this.post?.postAnalytics?.shares != null ? this.post?.postAnalytics?.shares : '-'; 
        this.allData.comments = this.post?.postAnalytics?.comments != null ? this.post?.postAnalytics?.comments : '-'; 
        this.allData.AffectedMembers = this.post?.postAnalytics?.AffectedMembers != null ? this.post?.postAnalytics?.AffectedMembers : '-'; 
        
        this.choiceMediaPreview();
        this.isLoadingLatestPost=false;
      }
    }));
    
  }

  choiceMediaPreview(){
    if(this.googleMedias.length > 0){
      this.mediaAllpreview = this.googleMedias[0];
      return
    }
    
    if(this.linkedinMedias.length > 0){
      this.mediaAllpreview = this.linkedinMedias[0];
      return
    }
    
    if(this.facebookMedias.length > 0){
      this.mediaAllpreview = this.facebookMedias[0];
      return
    }
    
    if(this.instagramMedias.length > 0){
      this.mediaAllpreview = this.instagramMedias[0];
      return
    }
    this.mediaAllpreview = null;
  }

  timeSince(dateString: string): string {
    if (dateString == null) {
        return '';
    }

    // Vérifier si la chaîne est un timestamp numérique
    const isTimestamp = /^\d+$/.test(dateString);
    const date = isTimestamp ? new Date(parseInt(dateString, 10)) : new Date(dateString);

    // Vérifier si la date est valide
    if (isNaN(date.getTime())) {
        return '';
    }

    const now = new Date();
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (seconds < 0) {
        const remainingSeconds = Math.abs(seconds);
        let interval = Math.floor(remainingSeconds / 31536000);
        if (interval >= 1) {
            return interval === 1 ? 'Il sera publié dans 1 an' : `Il sera publié dans ${interval} ans`;
        }
        interval = Math.floor(remainingSeconds / 2592000);
        if (interval >= 1) {
            return interval === 1 ? 'Il sera publié dans 1 mois' : `Il sera publié dans ${interval} mois`;
        }
        interval = Math.floor(remainingSeconds / 86400);
        if (interval >= 1) {
            return interval === 1 ? 'Il sera publié dans 1 jour' : `Il sera publié dans ${interval} jours`;
        }
        interval = Math.floor(remainingSeconds / 3600);
        if (interval >= 1) {
            return interval === 1 ? 'Il sera publié dans 1 heure' : `Il sera publié dans ${interval} heures`;
        }
        interval = Math.floor(remainingSeconds / 60);
        if (interval >= 1) {
            return interval === 1 ? 'Il sera publié dans 1 minute' : `Il sera publié dans ${interval} minutes`;
        }
        return 'Il sera publié dans quelques secondes';
    }

    let interval = Math.floor(seconds / 31536000);
    if (interval >= 1) {
        return interval === 1 ? 'Il y a 1 an' : `Il y a ${interval} ans`;
    }
    interval = Math.floor(seconds / 2592000);
    if (interval >= 1) {
        return interval === 1 ? 'Il y a 1 mois' : `Il y a ${interval} mois`;
    }
    interval = Math.floor(seconds / 86400);
    if (interval >= 1) {
        return interval === 1 ? 'Il y a 1 jour' : `Il y a ${interval} jours`;
    }
    interval = Math.floor(seconds / 3600);
    if (interval >= 1) {
        return interval === 1 ? 'Il y a 1 heure' : `Il y a ${interval} heures`;
    }
    interval = Math.floor(seconds / 60);
    if (interval >= 1) {
        return interval === 1 ? 'Il y a 1 minute' : `Il y a ${interval} minutes`;
    }
    return 'Il y a quelques secondes';
  }

  getLastPlannedPosts(){
    // Get the current date
    const currentDate = new Date();
    // Subtract one year from the current date
    const nextYear = new Date();
    nextYear.setFullYear(currentDate.getFullYear() + 1);
    if(this.screenHeight > 1000)
      this.navigation.limit = Number(this.navigation.limit)+1;
    this.subscriptions.push(this.postService.getPlannedByDateRange(currentDate, nextYear, this.currentGroups, this.navigation.limit,
    this.navigation.offset ).subscribe((res: any)=>{
      this.navigation = res.navigation;
      this.navigation.limit = Number(this.navigation.limit);
      this.navigation.offset = Number(this.navigation.offset);
      if (res.data.length > 0) {
        this.navigation.offset += this.navigation.limit;
      }
      this.plannedPosts = [...this.plannedPosts, ...res.data];
      this.plannedPosts = Array.from(new Map(this.plannedPosts.map((post: any) => [post.id, post])).values());

      this.dates = []

      this.plannedPosts.forEach((item: any)=>{
        this.getFormattedDate(item) 
			})
      this.isLoadingPlannedPost=false;
    }));
  }

  getFormattedDate(planned: any){
    let formatDate = this.datePipe.transform(planned?.expectedPublishingDatetime, 'EEEE dd M y') || ''
    if(!this.dates.includes(formatDate)){
      this.dates.push(formatDate)
      const dateElement = formatDate.split(' ')
      planned.day = dateElement[0]
      planned.dayNumb = dateElement[1]
      planned.month = dateElement[2]
      planned.year = dateElement[3]
    }
  }
  

  infinitScroll(event: any) {
    const element = event.target;
    // console.log('scrollTop', element.scrollTop, 'clientHeight', element.clientHeight, 'element.scrollHeight', element.scrollHeight);
    const isScrollingDown = element.scrollTop > this.previousScrollPosition;
    const isBottomReached = element.scrollHeight - element.scrollTop <= element.clientHeight+2;
    // console.log('isScrollingDown', isScrollingDown, 'isBottomReached', isBottomReached)
    if (isScrollingDown && isBottomReached) {
        this.getLastPlannedPosts(); // Load more posts
        // console.log("You've reached the end of this chunk");
    }
  
    // Update the previous scroll position
    this.previousScrollPosition = element.scrollTop;
  }
  
  gVal(data: any){
    return data && Number(data)? Number(data): '-'
  }
  
  toNumber(data: any){
    return data && Number(data)? Number(data): 0
  }

  renderInstaVal(name:string, instagramInsights: any){
    const insight=instagramInsights?.postAnalytics?.find((insight:any)=>insight.name == name)
    return insight?insight.value:'-'
  }


  isNotEmptyObject(obj: any): boolean {
    return obj && typeof obj === 'object' && Object.keys(obj).length !== 0;
  }

  isEmptyObject(obj: any): boolean {
    if (obj === null || typeof obj !== 'object') {
      return false;
    }
    return Object.getOwnPropertyNames(obj).length === 0;
  }

  resetIntialData(){
    this.post = {}; 
    this.plannedPosts = []; 
    this.linkedin  = false;
    this.google  = false;
    this.facebook  = false;
    this.instagram  = false;
    this.linkedinData = null;
    this.linkedinMedias = []
    this.googleData = null;
    this.googleMedias = []
    this.facebookData = null;
    this.facebookMedias = []
    this.instagramData = null;
    this.instagramMedias = []
    this.mediaAllpreview =  null;
    this.dates = []
    this.isLoading = false;
    this.doneLoadingPosts = false;
    this.previousScrollPosition = 0;
    this.allData = {};
    this.navigation = {
      limit: 3,
      itemsPerPage: 3,
      page: 0,
      offset: 0
    };
    this.groups = [];
  }
  
  ngAfterViewInit() {
    // Observer pour surveiller les changements de la taille de l'élément
    this.observeHeightChanges();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.observer) {
      this.observer.disconnect(); // Nettoyage lorsque le composant est détruit
    }
   
  }

  // Méthode pour observer les changements
  private observeHeightChanges() {
    this.observer = new MutationObserver(() => {
      this.updateHeight();
    });

    // Configurer l'observation des changements d'attributs et de style
    this.observer.observe(this.container.nativeElement, {
      attributes: true,
      childList: true,
      subtree: true
    });

    // Initialisation de la hauteur
    this.updateHeight();
  }

  // Mise à jour de la hauteur
  private updateHeight() {
    this.height = this.container.nativeElement.offsetHeight;
  }

  checkTruncation() : boolean{
    const element = this.elementRef.nativeElement.querySelector('.truncate-text');
    if (element) {
      return element.scrollWidth > element.clientWidth;
    }
    else 
      return false
  }

  getHour(date: any): string {
    if(date){
      const d = new Date(date);
      let postHour = String(d.getHours()).padStart(2, '0');
      let postMinute = String(d.getMinutes()).padStart(2, '0');
      return postHour+':'+postMinute
    }
    return '--:--'
  }

  setActiveTab(tab: any){
    this.activeTab = tab.id;
    this.top = tab.content;
    this.noStatsMsg = 'generic.no'+  tab.title.charAt(0).toUpperCase() +  tab.title.slice(1);
    if(this.top[0]?.insight == 0)
      this.hideStats = true;
    else
      this.hideStats = false;
  }

  getSRCByPlatform(source: string): string {
    if(source=='all')return ""
    return "assets/img/simple-logo-"+source+".png";
  }

  periodLabel:string='generic.last30Days'
  updateSelectedPeriod(value:any){
    this.periodLabel = value
    const ref =['generic.last30Days' ,'generic.last6Months','generic.lastYear']
    if(ref.indexOf(value)==0) this.selectedPeriod='30'
    if(ref.indexOf(value)==1) this.selectedPeriod='188'
    if(ref.indexOf(value)==2) this.selectedPeriod='365'

    this.topPosts(this.selectedPeriod)

  }
  notOnlyOnInstagram(post:any){
    const platforms = [...new Set(post.SocialPlatforms.map((p:any)=>p.source))]
    if(platforms.length==1 && platforms[0]=='instagram')return false
    return true
  }

  prepareData(){
    console.log("this.tabs",this.tabs)
    this.tabs.forEach((tab: any) => {
      for (let post of tab.content) {
        if(post){
            post.groups = [];
            post.platforms = [];
            post.linkedin = false;
            post.google = false;
            post.facebook = false;
            post.instagram = false;
            post.googleMedias = []
            post.linkedinMedias = []
            post.facebookMedias = []
            post.instagramMedias = []
            post.SocialPlatforms.forEach((item: { source: string; medias: any, group: any })=>{
              if (!post.groups.some((group: any) => group.id === item.group.id) && this.currentGroups.includes(item.group.id)){
                post.groups.push({id: item.group.id, name: item.group.name, logo: item.group.logoUrl})
              }
              if(!post.platforms.includes(item.source)){
                post.platforms.push(item.source)
              }
              if(item.source == "linkedin"){
                post.linkedin = true;
                if(item.medias.length>0)
                  post.googleMedias = item.medias;
              }
              if(item.source == "google"){
                post.google = true;
                if(item.medias.length>0)
                  post.linkedinMedias = item.medias;
              }
            if(item.source == "facebook"){
              post.facebook = true;
              if(item.medias.length>0)
                post.facebookMedias = item.medias;
              }
            if(item.source == "instagram"){
              post.instagram = true;
              if(item.medias.length>0)
                post.instagramMedias = item.medias;
              }
            })
          }
        }
    })
  }

  selectedPeriod: string = '30'; // Valeur par défaut
  topPosts(period: string){
    this.top = [];
    console.log("period",period)
    // console.log('this.currentGroups', this.currentGroups);
    let groups;
    if(this.user.isAdmin)
      groups = this.postService.getAdmniGroupFromLocalStorage();  
    else
      groups = this.currentGroups;

    this.subscriptions.push(this.postService.topPosts(period, groups).subscribe((res: any) => {
        this.tabs = [{
              id: '1',
              title: 'topImpressions',
              content: res?.data?.topImpressionPosts?.map((item: any) => {
                  const post = item.Post;
                  if (post){
                    post.insight = item.impression;
                    post.type = 'impressions';
                  } 
                  return post;
              }),
            },
            {
              id: '2',
              title: 'topComments',
              content: res?.data?.topCommentsPosts?.map((item: any) => {
                  const post = item.Post;
                  if (post){
                    post.insight = item.comments;
                    post.type = 'comments';
                  } 
                  return post;
              }),
            },
            {
              id: '3',
              title: 'topReactions',
              content: res?.data?.topReactionsPosts?.map((item: any) => {
                  const post = item.Post;
                  if (post){
                    post.insight = item.reactions;
                    post.type = 'reactions';
                  } 
                  return post;
              }),
            }
        ];
        this.setActiveTab(this.tabs[0]);
        this.prepareData();
        this.isLoadingTopPosts=false;
        
    }));
  }

  getComments(){
    const commentContainer = document.getElementById('commentContainer');
    const scrollPosition = commentContainer ? commentContainer.scrollTop : 0;
    this.subscriptions.push(this.postService.getComments(this.currentGroups).subscribe((res: any)=>{
      this.comments = res.data;
      if (commentContainer) {
        setTimeout(() => {
          commentContainer.scrollTop = scrollPosition;
        }, 0);
      }
      this.isLoadingComments=false;
    }))
  }
  
  goToPost(postId: string){
    window.location.href='/library/post-details/'+postId
  }

  dismissComment(commentId: any, index: any, j: any) {
    this.subscriptions.push(
      this.postService.dismissComment(commentId).subscribe((res: any) => {
        this.comments[index].comments.splice(j, 1);
        if(this.comments[index].comments.length == 0){
          this.comments.splice(index, 1);
        }
      })
    );
  }

  trackByCommentId(index: number, comment: any): any {
    return comment.id;
  }
}
